import styled from 'styled-components';

const ListItem = styled.div`
  display: flex;
  align-items: center;
  padding: 6px 0;
  font-family: inherit;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: inherit;

  :last-of-type {
    border-bottom: none;
  }
`;

export default ListItem;
